import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import Colors from '@components/shared/Colors';

interface Props {
  articleContentRef: React.MutableRefObject<HTMLDivElement | null>;
}

export default function ArticleProgressBar({ articleContentRef }: Props) {
  const [readingInProgress, setReadingInProgress] = useState(0);

  useEffect(() => {
    const scrollListener = () => {
      const articleContent = articleContentRef?.current;
      if (!articleContent || !articleContentRef.current) return;

      const totalHeight = (articleContent?.clientHeight ?? 0) - (articleContent?.offsetTop ?? 0);
      const windowScrollTop = window.scrollY || document.documentElement.scrollTop || document.body.scrollTop || 0;
      if (windowScrollTop === 0) {
        setReadingInProgress(0);
        return;
      }
      if (windowScrollTop > totalHeight) {
        setReadingInProgress(100);
        return;
      }
      setReadingInProgress((windowScrollTop / totalHeight) * 100);
    };

    window.addEventListener('scroll', scrollListener, { passive: true });
    return () => window.removeEventListener('scroll', scrollListener);
  }, [articleContentRef]);

  return (
    <Container>
      <Progress style={{ width: `${readingInProgress}%` }} />
    </Container>
  );
}

const Container = styled.div`
  width: 100%;
  height: 3px;
  display: flex;
  align-items: center;
  align-self: stretch;
  background: ${Colors.paleGold};
`;

const Progress = styled.div.attrs<{ style: { width: string } }>(({ style }) => ({
  style
}))`
  border-radius: 0px 2px 2px 0px;
  background: var(--Gold, #eba920);
  height: 3px;
`;
